<template src='./newConciliationCriteria.pug' lang='pug'></template>

<script>
import { Money } from 'v-money'
import vSelect from 'vue-select'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'
import ConciliationCritField from './ConciliationCritFields'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import idioma from '../../../../../build/language/index'
import ConfirmModal from '../../../../components/modals/confirmModal/ConfirmModal'
export default {
  name: 'NewConciliationCriteria',

  components: {
    Money,
    vSelect,
    PageTitle,
    FilterPortlet,
    InputEstablishment,
    ConciliationCritField,
    ButtonPrimary,
    ConfirmModal
  },

  props: {
    concilCriteriaToEdit: {
      type: Object,
      default: null
    },
    banks: {
      type: Array,
      default: null,
      required: true
    },
    accounts: {
      type: Array,
      default: null,
      required: true
    },
    attributesCfg: {
      type: Array,
      default: null,
      required: true
    },
    conciliationFields: {
      type: Array,
      default: null,
      required: true
    },
    occurrenceReasons: {
      type: Array,
      default: null,
      required: true
    }
  },

  data () {
    return {
      requestSent: false,
      criteriaConcil: {
        valorDiferencaMax: 0,
        valorDivergenciaMax: 0
      },
      filteredAccounts: [],
      attributes: [],
      establishimentsUrls: {
        establishments: 'conciliationPlan/establishment/list',
        attributes: '/conciliationPlan/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      moneyMask: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      },
      idioma: idioma,
      attributesMfList: [],
      attributesMbList: []
    }
  },

  computed: {
    mfFieldList () {
      let mfFieldList = []
      let self = this
      this.conciliationFields.map(field => {
        let alreadyUsed = false
        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos
        if (self.criteriaConcil.conciliacaoCampos && self.criteriaConcil.conciliacaoCampos.length > 0) {
          alreadyUsed = self.criteriaConcil.conciliacaoCampos.findIndex(concField => (concField.conciliacaoCampoMovFinan ? concField.conciliacaoCampoMovFinan.id : null) === field.id && field.tipo !== 'A') !== -1
        }

        if (!(field.tipo === 'B') && !alreadyUsed) {
          mfFieldList.push(field)
        }
      })
      return mfFieldList
    },

    mbFieldList () {
      let mbFieldList = []
      let self = this
      this.conciliationFields.map(field => {
        let alreadyUsed = false
        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos
        if (self.criteriaConcil.conciliacaoCampos && self.criteriaConcil.conciliacaoCampos.length > 0) {
          alreadyUsed = self.criteriaConcil.conciliacaoCampos.findIndex(concField => (concField.conciliacaoCampoMovBancario ? concField.conciliacaoCampoMovBancario.id : null) === field.id && field.tipo !== 'A') !== -1
        }

        if (field.tipo === 'B' && !alreadyUsed) {
          mbFieldList.push(field)
        }
      })
      return mbFieldList
    },

    attributesCfgMfList () {
      let attributesCfgMf = []
      this.attributesCfg.map(cfg => {
        attributesCfgMf.push(cfg)
      })
      return attributesCfgMf
    }
  },

  watch: {
    concilCriteriaToEdit: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.criteriaConcil = {...newVal, conciliacaoCampos: [...newVal.conciliacaoCampos]}
          if (this.criteriaConcil.valorDiferencaMax === 0 || !this.criteriaConcil.valorDiferencaMax) {
            this.criteriaConcil.valorDiferencaMax = '0'
          }
          if (this.criteriaConcil.valorDivergenciaMax === 0) {
            this.criteriaConcil.valorDivergenciaMax = '0'
          }
          if (this.criteriaConcil.conciliacaoEstabelecimentos && this.criteriaConcil.conciliacaoEstabelecimentos.length > 0) {
            this.selectedEstablishments = [...this.criteriaConcil.conciliacaoEstabelecimentos]
          } else {
            this.selectedEstablishments = []
          }
        } else {
          this.criteriaConcil = {
            ativo: true,
            criterioEmUso: false,
            conciliacaoCampos: [],
            conta: null,
            banco: null,
            descricao: '',
            estabelecimentos: [],
            diasDiferencaMin: 0,
            diasDiferencaMax: 0,
            valorDiferencaMax: 0,
            valorDivergenciaMax: 0,
            motivoOcorrencia: null
          }
        }
      }
    },
    accounts: {
      handler (newVal, oldVal) {
        this.filteredAccounts = [...newVal]
      }
    }
  },

  methods: {
    back () {
      this.$emit('change-managing-plan-concil')
      this.errors.clear()
      this.requestSent = false
    },

    validate (event) {
      this.requestSent = true
      if (event) {
        event.preventDefault()
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.criteriaConcil.valorDivergenciaMax) {
            this.openConfirmationModal()
            this.requestSent = false
            return
          }
          this.submitCriteria()
        } else {
          this.requestSent = false
        }
      })
    },
    submitCriteria () {
      let self = this
      setTimeout(() => {
        if (this.verifyFields) {
          self.addCriteria()
        } else {
          this.requestSent = false
        }
      }, 500)
    },
    verifyFields () {
      let self = this
      let isAllFieldsValid = true
      Object.entries(self.$refs).map(refArray => {
        if (refArray[1] && refArray[1].length > 0) {
          refArray[1][0].$validator.validateAll().then((fieldValidation) => {
            if (isAllFieldsValid) {
              isAllFieldsValid = fieldValidation
            }
          })
        }
      })
      return isAllFieldsValid
    },
    addCriteria () {
      if (this.selectedEstablishments && this.selectedEstablishments.length > 0) {
        this.criteriaConcil.conciliacaoEstabelecimentos = [...this.selectedEstablishments]
        this.criteriaConcil.flEstabelecimento = true
      } else {
        this.criteriaConcil.conciliacaoEstabelecimentos = null
        this.criteriaConcil.flEstabelecimento = false
      }
      this.$emit('add-concil-criteria-to-plan', this.criteriaConcil)
      this.back()
    },

    addConciliationField () {
      if (!this.criteriaConcil.conciliacaoCampos) {
        this.criteriaConcil.conciliacaoCampos = []
      }

      this.criteriaConcil.conciliacaoCampos.push({
        idCriterioClassificacao: this.criteriaConcil.idCriterioClassificacao,
        atributo: {
          atributoCfg: null,
          nomeAtributo: null
        },
        conciliacaoCampoMovBancario: null,
        conciliacaoCampoMovFinan: null,
        key: this.criteriaConcil.conciliacaoCampos.length + 1
      })
    },

    removeConciliationField (field) {
      const index = this.criteriaConcil.conciliacaoCampos.findIndex(item => item.key === field.key)
      this.criteriaConcil.conciliacaoCampos.splice(index, 1)
      if (field.id) {
        if (!this.criteriaConcil.idsCamposRemovidos) {
          this.criteriaConcil.idsCamposRemovidos = []
        }
        this.criteriaConcil.idsCamposRemovidos.push(field.id)
      }
    },

    changeFieldAttCfgMf (item) {
      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {
        // identifica a configuracao alterada
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          if (!mappedItem.atributo) {
            mappedItem.atributo = {}
          }
          mappedItem.atributo.atributoCfg = item.cfg
          mappedItem.atributo.nomeAtributo = null
          if (item.cfg) {
            // atualiza lista de atributos com os filhos do conjunto
            this.attributesMfList = item.cfg.children
          } else {
            this.attributesMfList = []
          }
        }
      })
    },

    changeFieldAttNameMf (item) {
      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {
        // identifica a configuracao
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          mappedItem.atributo.nomeAtributo = item.att
        }
      })
    },

    changeFieldAttConciliationFieldMf (item) {
      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {
        // identifica a configuracao
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          mappedItem.conciliacaoCampoMovFinan = item.field
          if (item.field && item.field.tipo === 'A') {
            mappedItem.atributo = {
              atributoCfg: null,
              nomeAtributo: null
            }
          } else {
            mappedItem.atributo = null
          }
        }
      })
    },

    changeFieldAttConciliationFieldMb (item) {
      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {
        // identifica a configuracao
        if (mappedItem.key === item.concField.key) {
          // atualiza campo
          mappedItem.conciliacaoCampoMovBancario = item.field
        }
      })
    },

    changeCritBank (val) {
      this.criteriaConcil.conta = null
      if (val && val.codigo) {
        this.criteriaConcil.banco = val
        this.filteredAccounts = this.accounts.filter(account => {
          return account.banco.codigo === val.codigo || account.id === 0
        })
      } else {
        this.criteriaConcil.banco = null
        this.filteredAccounts = [...this.accounts]
      }
    },

    updateAttibutesList (item) {
      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {
        // identifica a configuracao alterada
        if (mappedItem.key === item.concField.key) {
          if (item.cfg) {
            // atualiza lista de atributos com os filhos do conjunto
            this.attributesMfList = item.cfg.children
          } else {
            this.attributesMfList = []
          }
        }
      })
    },
    openConfirmationModal () {
      this.verifyFields()
      this.showConfirmationModal()
    },
    confirmAdd () {
      this.closeModal()
      this.submitCriteria()
    },
    closeModal () {
      $('#confirmDivergMax').modal('hide')
    },
    showConfirmationModal () {
      $('#confirmDivergMax').modal({ backdrop: 'static', keyboard: false })
    }
  },

  mounted () {
    this.moneyMask = this.idioma.getMoneyMaskByLanguage()
  }
}
</script>

<style scoped>
.marged-button {
  margin-left: 10px;
}

.alert-icon {
  margin-right: 10px;
  color: red;
  font-size: 20px;
}

.alert-text {
  color: red;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// NewConciliationCriteria.vue?3f8c5b74